'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
function isValidPhoneNumber(value, type) {
	switch (type) {
		case 'AreaCode':
			return (/^([2-9]\d{2})$/.test(value)
			);
		case 'Number':
			return (/^([2-9]\d{6})$/.test(value)
			);
		default:
			return (/^([2-9]\d{9})$/.test(value)
			);
	}
}

exports.default = isValidPhoneNumber;